import { API_HOST, getHttpGetOptions, getHttpPostOptions } from '../../utils/api-util';

const getEndpoint = (externalReference) => `${API_HOST}/programme/${externalReference}/teams`;

export const getViewTeamsForProgrammeRequest = (externalReference) => [
  getEndpoint(externalReference),
  getHttpGetOptions()
];

const getDownloadTeamExcelEndpoint = (externalReference) => `${getEndpoint(externalReference)}/download`;
export const getDownloadTeamExcelRequest = (externalReference) => [
  getDownloadTeamExcelEndpoint(externalReference),
  getHttpGetOptions()
];

const getUploadTeamExcelEndpoint = (externalReference) => `${getEndpoint(externalReference)}/upload`;
export const getUploadTeamExcelRequest = (externalReference, data) => [
  getUploadTeamExcelEndpoint(externalReference),
  getHttpPostOptions({ data })
];

const getViewTeamLeaderboardEndpoint = (externalReference) => `${getEndpoint(externalReference)}/leaderboard`;
export const getViewTeamLeaderboardRequest = (externalReference) => [
  getViewTeamLeaderboardEndpoint(externalReference),
  getHttpGetOptions()
];
